<div class="confirm-payment-page" role="main" aria-label="Confirm payment page" *ngIf="fine; else noPaymentData">
    <div class="confirm-header">
        <h2 [appTranslate]="'CONTINUE_PAYMENT_FINE'"></h2>
    </div>
    <div class="confirm-payment-card">
        <div class="summary-row">
            <span [appTranslate]="'VEHICLE'"></span>
            <b>{{fine.CarNo}}</b>
        </div>
        <div class="summary-row">
            <span [appTranslate]="'ZONE'"></span>
            <b>{{fine.AssetOwnerUniqueID}}</b>
        </div>

        <div class="summary-row">
            <span [appTranslate]="'DATE'"></span>
            <b>{{fine.ActivateTimeText}}</b>
        </div>
        <div class="summary-row">
            <span [appTranslate]="'REFERENCE'"></span>
            <b>{{fine.BankReference}}</b>
        </div>
        <div class="total-row">
            <span [appTranslate]="'TOTAL_SUM'"></span>
            <div class="total-amount">
                <strong>{{fine.Amount | number:'1.2-2'}}</strong>
                <b [appTranslate]="'DENARS'"></b>
            </div>
        </div>

        <div class="profile-actions jusitfy-content-between">
            <button type="button" class="btn btn-next" (click)="goToFines()">
                <span [appTranslate]="'CANCEL'"></span>
            </button>
            <button type="button" class="btn btn-primary" (click)="pay()">
                <span [appTranslate]="'TO_PAYMENT'"></span>
            </button>
        </div>

        <div class="errors" *ngIf="hasErrors">
            <span class="error">{{errorsMessages}}</span>
        </div>
    </div>
</div>

<ng-template #noPaymentData>
    <div class="confirm-payment-page empty-state">
        <div class="confirm-payment-card">
            <p [appTranslate]="'NO_DATA'">No payment data available.</p>
            <div class="profile-actions">
                <button type="button" class="btn btn-next" (click)="goToFines()">
                    <span [appTranslate]="'CANCEL'"></span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<div class="loader" *ngIf="myLoaderService.isLoading | async"></div>